<input
    *ngFor="let option of options"
    [formControl]="componentFormControl"
    [id]="option.id"
    [value]="option.value"
    type="radio"
/>

<label
    *ngFor="let option of options"
    [class.isSelected]="componentFormControl.value === option.value"
    [class.isDisabled]="componentFormControl.disabled"
    [class.showOnlySelected]="showOnlySelected"
    [for]="option.id"
>
    {{ option.label }}
</label>
